export type TabMessage = {
  type: 'REFRESH_ACCOUNT_DETAILS' | 'REFRESH_CREDITS';
  payload?: any;
};

export class ServiceWorkerService {
  private static instance: ServiceWorkerService;
  private isServiceWorkerSupported: boolean;

  private constructor() {
    this.isServiceWorkerSupported = 'serviceWorker' in navigator;
  }

  public static getInstance(): ServiceWorkerService {
    if (!ServiceWorkerService.instance) {
      ServiceWorkerService.instance = new ServiceWorkerService();
    }
    return ServiceWorkerService.instance;
  }

  public async postMessage(message: TabMessage): Promise<void> {
    if (!this.isServiceWorkerSupported) {
      console.warn('Service Worker is not supported in this browser');
      return;
    }

    try {
      // Wait for service worker to be ready
      const registration = await navigator.serviceWorker.ready;
      if (registration.active) {
        registration.active.postMessage(message);
      }
    } catch (error) {
      console.warn('Failed to post message to service worker:', error);
    }
  }
}

export const serviceWorkerService = ServiceWorkerService.getInstance();
